import { TCustomListInvitationRoles } from './../AddToList/shared.d';
import { useLocation } from 'react-router';
import { useMemo } from 'react';

interface IUseInvitationUrl {
  role: TCustomListInvitationRoles;
  invitationId?: string;
}

function useInvitationUrl(props: IUseInvitationUrl): any {
  const { role, invitationId } = props;

  const origin = window.location.origin;
  const location = useLocation();

  return useMemo(
    () =>
      role === 'admin'
        ? `${origin}${location.pathname}/invitation/${invitationId}`
        : `${origin}${location.pathname}`,
    [invitationId, location, origin, role]
  );
}

export default useInvitationUrl;
